@if (
  !nuclearTopicsDistrEnriched.categories_distribution_available && !isLoading
) {
  <div class="no-graphic">
    <img
      src="assets/imgs/undraw/undraw_no_data.svg"
      alt="Distribuzione dei topic nucleari non disponibile"
    />
    <span>Distribuzione dei topic nucleari non disponibile</span>
  </div>
}

@if (
  nuclearTopicsDistrEnriched.categories_distribution_available && !isLoading
) {
  <section>
    <canvas #chart class="chart"></canvas>
  </section>
}
@if (
  nuclearTopicsDistrEnriched.categories_distribution_available && !isLoading
) {
  <section class="topics-explanations">
    <h1 class="graph-title">Descrizione Topic Nucleari</h1>
    @for (topic of nuclearTopicsExplanation; track topic) {
      <div class="category-container">
        <span class="category-title">{{ topic.topic }}</span>
        <span class="category-description">{{ topic.description }}</span>
      </div>
    }
  </section>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}
